import { mapValues, isArray, reduce } from 'lodash'

export function createActionTypes(options, namespace = '') {
  let types = options

  if (isArray(options)) {
    types = reduce(
      options,
      (result, item) => {
        return {
          ...result,
          [item]: item
        }
      },
      {}
    )
  }
  return mapValues(types, v => [namespace, v].join('.'))
}
export function defineTypes(types, namespace = '') {
  let defineObject = (current, property) => {
    Object.defineProperty(current, property, {
      value: `${namespace}.${current[property]}`,
      writable: false
    })
  }
  Object.keys(types).forEach(property => defineObject(types, property))
}
